export const CONNECT_STREAM_POS_PERMISSIONS = [
  'Read menu information',
  'Read order information',
  'Read stock information',
  'Read digital schedule information',
  'Read restaurant configuration information',
  'Other permissions (Internal only)',
  'Write order information'
];

export const CONNECT_STREAM_DSP_PERMISSIONS = [
  'View your merchant profile information',
  'Update your Sauce location settings',
  'Change and update your menu data',
  'View your Sauce orders',
  'Update your Sauce orders'
];
